import { useQuery } from '@hooks/reactQuery';

import { getPortalFilesMilestonesFilter } from '@api/portalFiles';

import { extractQueryParams } from '@utils/common';
import { optionsFormattedWithId } from '@utils/formatter';

import { TNameTitleValueLabel } from '@interfaces/common/common';

import { EUserRoles } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { GET_PORTAL_FILES_MILESTONES_FILTER } from '@constants/queryKeys';

interface IUseQueryPortalFilesMilestonesReturned {
	portalFilesMilestonesFilter: TNameTitleValueLabel[];
	isLoadingPortalFilesMilestonesFilter: boolean;
}

export const useQueryPortalFilesMilestonesFilter = (projectId?: string): IUseQueryPortalFilesMilestonesReturned => {
	const {
		data,
		isInitialLoading,
	} = useQuery({
		queryKey: [GET_PORTAL_FILES_MILESTONES_FILTER, { projectId }],
		queryFn: extractQueryParams(getPortalFilesMilestonesFilter),
		enabled: [projectId],
		allowedRoles: [EUserRoles.portalProjectAdministrator, EUserRoles.portalProjectMember],
		select: requestTypes => optionsFormattedWithId(requestTypes),
		...refetchOptions,
	});

	return {
		portalFilesMilestonesFilter: data || [],
		isLoadingPortalFilesMilestonesFilter: isInitialLoading,
	};
};
